/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';

/**
 * 
 * @export
 * @interface CreateUserBody
 */
export interface CreateUserBody {
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    confirmPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    email: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof CreateUserBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    onboardingSignedUrlKey?: string;
    /**
     * Date of birth as an epoch millisecond timestamp
     * @type {number}
     * @memberof CreateUserBody
     */
    dateOfBirth?: number;
}

/**
 * Check if a given object implements the CreateUserBody interface.
 */
export function instanceOfCreateUserBody(value: object): value is CreateUserBody {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function CreateUserBodyFromJSON(json: any): CreateUserBody {
    return CreateUserBodyFromJSONTyped(json, false);
}

export function CreateUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserBody {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'] == null ? undefined : json['password'],
        'confirmPassword': json['confirmPassword'] == null ? undefined : json['confirmPassword'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'referralCode': json['referralCode'] == null ? undefined : json['referralCode'],
        'onboardingSignedUrlKey': json['onboardingSignedUrlKey'] == null ? undefined : json['onboardingSignedUrlKey'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
    };
}

export function CreateUserBodyToJSON(json: any): CreateUserBody {
    return CreateUserBodyToJSONTyped(json, false);
}

export function CreateUserBodyToJSONTyped(value?: CreateUserBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'confirmPassword': value['confirmPassword'],
        'email': value['email'],
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'referralCode': value['referralCode'],
        'onboardingSignedUrlKey': value['onboardingSignedUrlKey'],
        'dateOfBirth': value['dateOfBirth'],
    };
}

